// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationResponseLineItem {
    static getAttributeTypeMap() {
        return ClaimAdjudicationResponseLineItem.attributeTypeMap;
    }
}
ClaimAdjudicationResponseLineItem.discriminator = undefined;
ClaimAdjudicationResponseLineItem.attributeTypeMap = [
    {
        "name": "amountPaid",
        "baseName": "amountPaid",
        "type": "number"
    },
    {
        "name": "claimLineId",
        "baseName": "claimLineId",
        "type": "number"
    },
    {
        "name": "rejectionCodes",
        "baseName": "rejectionCodes",
        "type": "Array<string>"
    },
    {
        "name": "adjudicationCodes",
        "baseName": "adjudicationCodes",
        "type": "Array<ClaimAdjudicationResponseLineItemAdjudicationCode>"
    }
];
//# sourceMappingURL=claimAdjudicationResponseLineItem.js.map